import {Component, ChangeDetectionStrategy, inject,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {SessionService} from "~core/services/session.service";


// Import shared components
import { HeaderComponent } from '~shared/components/header/header.component';
import { FooterComponent } from '~shared/components/footer/footer.component';
import {LoginComponent} from "~features/authentication/pages/login/login.component";
  import {ToastStackComponent} from "~shared/components/toast-stack/toast-stack.component";
import {RouterOutlet,ActivatedRoute} from "@angular/router";
import {NgHttpLoaderComponent} from "ng-http-loader";


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    LoginComponent,
    // Shared components
    HeaderComponent,
    FooterComponent,
    ToastStackComponent,
    RouterOutlet,
    NgHttpLoaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent {
   sessionService: SessionService=inject(SessionService);
}
